// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faq_questionCol {
  display: flex;
  align-items: center;
  font-size: 1.2vw;
  padding-left: 1rem;
}
@media (max-width: 1200px) {
  .faq_questionCol {
    font-size: 2vw;
  }
}
@media (max-width: 992px) {
  .faq_questionCol {
    font-size: 2.5vw;
  }
}
@media (max-width: 768px) {
  .faq_questionCol {
    font-size: 2.5vw;
  }
}
@media (max-width: 576px) {
  .faq_questionCol {
    font-size: 4vw;
  }
}

.faq_questionRow {
  color: #fff;
}

:where(.css-dev-only-do-not-override-10ed4xt).ant-collapse .ant-collapse-content > .ant-collapse-content-box {
  background: #1d1a36;
  color: #fff;
  border-top: 1px solid var(--Gradient_blue_orange, #ffb6a0);
}

:where(.css-dev-only-do-not-override-10ed4xt).ant-collapse .ant-collapse-content {
  color: rgba(0, 0, 0, 0.88);
  background-color: #ffffff;
  border-top: 0px solid #b82727;
  margin: 0 1rem;
}

.collapseDiv {
  background: #1d1a36;
}

.panelView div {
  margin-top: 2vw;
}

.upDownIcon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.layoutProductBannerHead {
  text-align: center;
  color: #fff;
  font-size: 5.5vw;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 150%;
}
@media (max-width: 600px) {
  .layoutProductBannerHead {
    font-size: 2.5rem;
  }
}

.layoutProductBannerImg {
  height: 36vw;
  background-repeat: no-repeat;
  background-size: contain;
}

.faq-imgIcon {
  width: 3vw !important;
}
@media (min-width: 1920px) {
  .faq-imgIcon {
    width: 3vw !important;
  }
}
@media (max-width: 1200px) {
  .faq-imgIcon {
    width: 4vw !important;
  }
}
@media (max-width: 992px) {
  .faq-imgIcon {
    width: 4vw !important;
  }
}
@media (max-width: 768px) {
  .faq-imgIcon {
    width: 5vw !important;
  }
}
@media (max-width: 576px) {
  .faq-imgIcon {
    width: 10vw !important;
  }
}

.faq_answerFaq {
  line-height: 150%;
}`, "",{"version":3,"sources":["webpack://./src/Components/FAQ/faq.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAAE;EALF;IAMI,cAAA;EAGF;AACF;AAFE;EARF;IASI,gBAAA;EAKF;AACF;AAJE;EAXF;IAYI,gBAAA;EAOF;AACF;AANE;EAdF;IAeI,cAAA;EASF;AACF;;AAPA;EACE,WAAA;AAUF;;AARA;EAIE,mBAAA;EACA,WAAA;EACA,0DAAA;AAQF;;AANA;EACE,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,cAAA;AASF;;AANA;EACE,mBAAA;AASF;;AANA;EACE,eAAA;AASF;;AANA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AASF;;AANA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;AASF;AAPE;EARF;IASI,iBAAA;EAUF;AACF;;AARA;EACE,YAAA;EAEA,4BAAA;EACA,wBAAA;AAUF;;AAPA;EACE,qBAAA;AAUF;AATE;EAFF;IAGI,qBAAA;EAYF;AACF;AAXE;EALF;IAMI,qBAAA;EAcF;AACF;AAbE;EARF;IASI,qBAAA;EAgBF;AACF;AAfE;EAXF;IAYI,qBAAA;EAkBF;AACF;AAjBE;EAdF;IAeI,sBAAA;EAoBF;AACF;;AAjBA;EACE,iBAAA;AAoBF","sourcesContent":[".faq_questionCol {\n  display: flex;\n  align-items: center;\n  font-size: 1.2vw;\n  padding-left: 1rem;\n  @media (max-width: \"1200px\") {\n    font-size: 2vw;\n  }\n  @media (max-width: \"992px\") {\n    font-size: 2.5vw;\n  }\n  @media (max-width: \"768px\") {\n    font-size: 2.5vw;\n  }\n  @media (max-width: \"576px\") {\n    font-size: 4vw;\n  }\n}\n.faq_questionRow {\n  color: #fff;\n}\n:where(.css-dev-only-do-not-override-10ed4xt).ant-collapse\n  .ant-collapse-content\n  > .ant-collapse-content-box {\n\n  background: #1d1a36;\n  color: #fff;\n  border-top: 1px solid var(--Gradient_blue_orange, #ffb6a0);\n}\n:where(.css-dev-only-do-not-override-10ed4xt).ant-collapse .ant-collapse-content {\n  color: rgba(0, 0, 0, 0.88);\n  background-color: #ffffff;\n  border-top: 0px solid #b82727;\n  margin: 0 1rem;\n}\n\n.collapseDiv {\n  background: #1d1a36;\n}\n\n.panelView div {\n  margin-top: 2vw;\n}\n\n.upDownIcon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.layoutProductBannerHead {\n  text-align: center;\n  color: #fff;\n  font-size: 5.5vw;\n  font-weight: 700;\n  text-transform: uppercase;\n  line-height: 150%;\n\n  @media (max-width: 600px) {\n    font-size: 2.5rem;\n  }\n}\n.layoutProductBannerImg {\n  height: 36vw;\n\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.faq-imgIcon {\n  width: 3vw !important;\n  @media (min-width: \"1920px\") {\n    width: 3vw !important;\n  }\n  @media (max-width: \"1200px\") {\n    width: 4vw !important;\n  }\n  @media (max-width: \"992px\") {\n    width: 4vw !important;\n  }\n  @media (max-width: \"768px\") {\n    width: 5vw !important;\n  }\n  @media (max-width: \"576px\") {\n    width: 10vw !important;\n  }\n}\n\n.faq_answerFaq{\n  line-height: 150%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
